<div class="container-fluid spacer-top-navigation">
  <div class="container row--primary">
    <web-components-user-notes target="user-self-service" [dismissibleNotes]="true" />
    <div class="mt-4 tile p-3">
      <h1 class="mb-4 zero-text p-bigger-med">{{ 'user-self-service.headline' | transloco }}</h1>
      <web-design-system-divider type="light" />
      <div class="col-12">
        <self-service-konto-depot [showMe]="section === 'konto-depot'" />
      </div>
      <web-design-system-divider type="light" />
      <div class="col-12">
        <self-service-krypto-wallet [showMe]="section === 'krypto-wallet'" />
      </div>
      <web-design-system-divider type="light" />
      <div class="col-12">
        <self-service-tax [showMe]="section === 'tax'" />
      </div>
      <web-design-system-divider type="light" />
      <div class="col-12">
        <self-service-user-contact-data [showMe]="section === 'user-contact-data'" />
      </div>
      <web-design-system-divider type="light" />
      <div class="col-12">
        <self-service-depot [showMe]="section === 'depot'" />
      </div>
      <web-design-system-divider type="light" />
      <div class="col-12">
        <self-service-security [showMe]="section === 'security'" />
      </div>
      <web-design-system-divider type="light" />
      <div class="col-12">
        <self-service-notification-administration [showMe]="section === 'notification-administration'" />
      </div>
      <web-design-system-divider type="light" />
      <div class="col-12">
        <self-service-kunden-werben [showMe]="section === 'kunden-werben'" />
      </div>
    </div>
  </div>
</div>
